import script from "./FlightComboDetailsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FlightComboDetailsCard.vue?vue&type=script&setup=true&lang=js"

import "./FlightComboDetailsCard.vue?vue&type=style&index=0&id=ed690116&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed690116"]])

export default __exports__